<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ContaPagarReceber from '@/src/services/conta-pagar-receber'
import CategoriaConta from '@/src/services/categoria-conta'
import CentroCusto from '@/src/services/centro-custo'
import TipoConta from '@/src/services/tipo-conta'
import produtor from '@/src/services/produtor-rural'
import formProdutor from '@/src/components/form-produtor'
import { VMoney } from 'v-money'
import moment from 'moment'
moment.locale('pt-br')
var currencyFormatter = require('currency-formatter')

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formProdutor },
  directives: { money: VMoney },
  data() {
    return {
      filter: '',
      listStatusFilter: 'todos',
      filterStartDate: '',
      filterEndDate: '',
      filterDebounce: null,
      showAdvancedFilters: false,
      mostraForm: true,
      showHistory: false,
      quickModalType: '',
      quickClient: {
        nome: '',
        cpf_cnpj: '',
        telefone: '',
        email: '',
        propriedade: '',
      },
      quickCategory: {
        descricao: '',
        ativo: true,
      },
      quickCostCenter: {
        descricao: '',
        ativo: true,
      },
      isLoading: false,
      idDelete: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      accountFrequency: [
        { value: 'semanalmente', text: 'Semanalmente' },
        { value: 'quinzenalmente', text: 'Quinzenalmente' },
        { value: 'mensalmente', text: 'Mensalmente' },
      ],
      numberOccurrences: [
        { value: '1', text: '1 vez' },
        { value: '2', text: '2 vezes' },
        { value: '3', text: '3 vezes' },
        { value: '4', text: '4 vezes' },
        { value: '5', text: '5 vezes' },
        { value: '6', text: '6 vezes' },
        { value: '7', text: '7 vezes' },
        { value: '8', text: '8 vezes' },
        { value: '9', text: '9 vezes' },
        { value: '10', text: '10 vezes' },
        { value: '11', text: '11 vezes' },
        { value: '12', text: '12 vezes' },
      ],
      contasAreceber: [],
      resumoReceber: null,
      categoriasConta: [],
      centroCusto: [],
      tiposConta: [],
      produtores: [],
      contaAReceberEdit: {
        frquencySelected: 'mensalmente',
      },
      contasAreceberField: [
        {
          key: 'descricao',
          label: 'Descrição',
          //class: 'size-col-20',
        },
        {
          key: 'cliente',
          label: 'Cliente',
          //class: 'size-col-20',
        },
        {
          key: 'data_competencia',
          label: 'Competência',
          //class: 'size-col-20',
        },
        {
          key: 'data_vencimento',
          label: 'Vencimento',
          //class: 'size-col-20',
        },
        {
          key: 'valor',
          label: 'Valor',
          //class: 'size-col-20',
        },
        {
          key: 'diff',
          label: 'Status',
          //class: 'size-col-20',
        },
        { key: 'actions', label: '' /*, class: 'size-col-10'*/ },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      rows: 0,
    }
  },
  computed: {
    resumoCliente() {
      return this.getOptionLabel(
        this.produtores,
        'id_produtor_rural',
        this.contaAReceberEdit.id_cliente,
        'nome',
        'Cliente não selecionado'
      )
    },
    resumoCategoria() {
      return this.getOptionLabel(
        this.categoriasConta,
        'id',
        this.contaAReceberEdit.id_categoria,
        'descricao',
        'Categoria não selecionada'
      )
    },
    resumoConta() {
      return this.getOptionLabel(
        this.tiposConta,
        'id',
        this.contaAReceberEdit.id_tipo_conta,
        'tipo',
        'Conta não selecionada'
      )
    },
    resumoVencimento() {
      return this.formatPreviewDate(this.contaAReceberEdit.data_vencimento)
    },
    resumoCompetencia() {
      return this.formatPreviewDate(this.contaAReceberEdit.data_competencia)
    },
    resumoValor() {
      return this.contaAReceberEdit.valor || 'R$ 0,00'
    },
    resumoRecorrencia() {
      if (!this.contaAReceberEdit.repetir) return 'Não repetir'
      const frequency = this.accountFrequency.find(
        (item) => item.value === this.contaAReceberEdit.frquencySelected
      )
      const vezes = this.contaAReceberEdit.vezes || '1'
      return `${frequency ? frequency.text : 'Mensalmente'} por ${vezes} vezes`
    },
    proximoVencimento() {
      if (!this.contaAReceberEdit.data_vencimento) return 'Defina o vencimento'
      const frequency = this.contaAReceberEdit.frquencySelected || 'mensalmente'
      const amount =
        frequency === 'semanalmente'
          ? 7
          : frequency === 'quinzenalmente'
          ? 15
          : 1
      const unit = frequency === 'mensalmente' ? 'month' : 'day'
      return moment
        .utc(this.contaAReceberEdit.data_vencimento)
        .add(amount, unit)
        .format('DD/MM/YYYY')
    },
    diasAteVencimento() {
      if (!this.contaAReceberEdit.data_vencimento) return ''
      const diff = this.diffDate(this.contaAReceberEdit.data_vencimento)
      if (diff === 0) return 'Vence hoje'
      if (diff > 0) return `Em ${diff} ${diff === 1 ? 'dia' : 'dias'}`
      return `${Math.abs(diff)} ${Math.abs(diff) === 1 ? 'dia' : 'dias'} em atraso`
    },
    historyClient() {
      const produtores = Array.isArray(this.produtores) ? this.produtores : []
      return (
        produtores.find(
          (item) =>
            String(this.getPersonId(item)) === String(this.contaAReceberEdit.id_cliente)
        ) || {}
      )
    },
    historyRows() {
      const contas = Array.isArray(this.contasAreceber) ? this.contasAreceber : []
      if (!this.contaAReceberEdit.id_cliente) return contas
      return contas.filter(
        (item) => String(item.id_cliente) === String(this.contaAReceberEdit.id_cliente)
      )
    },
    historyTotalReceber() {
      return this.formatMoney(
        this.historyRows
          .filter((item) => !item.pago)
          .reduce((total, item) => total + this.itemFinalNumber(item), 0)
      )
    },
    historyTotalRecebido() {
      return this.formatMoney(
        this.historyRows
          .filter((item) => item.pago)
          .reduce((total, item) => total + this.itemFinalNumber(item), 0)
      )
    },
    historyTotalAtraso() {
      return this.formatMoney(
        this.historyRows
          .filter((item) => !item.pago && this.diffDate(item.data_vencimento) < 0)
          .reduce((total, item) => total + this.itemFinalNumber(item), 0)
      )
    },
    historyLastPayment() {
      const receivedRows = this.historyRows.filter((item) => item.pago)
      if (!receivedRows.length) return '--/--/----'
      const orderedRows = [...receivedRows].sort((a, b) =>
        moment.utc(b.data_recebimento || b.data_vencimento).diff(
          moment.utc(a.data_recebimento || a.data_vencimento)
        )
      )
      return this.formatPreviewDate(
        orderedRows[0].data_recebimento || orderedRows[0].data_vencimento
      )
    },
    receivableRows() {
      return Array.isArray(this.contasAreceber) ? this.contasAreceber : []
    },
    filteredReceivableRows() {
      const search = this.filter ? this.filter.toLowerCase().trim() : ''
      return this.receivableRows.filter((item) => {
        const status = this.listStatus(item)
        const statusMatches =
          this.listStatusFilter === 'todos' ||
          status.toLowerCase() === this.listStatusFilter
        const content = [
          item.cliente,
          item.cliente_nome,
          item.descricao,
          item.valor,
          item.valor_formatado,
          item.data_vencimento,
          item.id,
        ]
          .join(' ')
          .toLowerCase()
        return statusMatches && (!search || content.includes(search))
      })
    },
    totalReceberDashboard() {
      if (this.resumoReceber && this.resumoReceber.total_a_receber_formatado) {
        return this.resumoReceber.total_a_receber_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => !item.pago)
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
    vencendoHojeDashboard() {
      if (this.resumoReceber && this.resumoReceber.vencendo_hoje_formatado) {
        return this.resumoReceber.vencendo_hoje_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => !item.pago && this.diffDate(item.data_vencimento) === 0)
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
    vencendoHojeCount() {
      return this.receivableRows.filter(
        (item) => !item.pago && this.diffDate(item.data_vencimento) === 0
      ).length
    },
    atrasadosDashboard() {
      if (this.resumoReceber && this.resumoReceber.atrasados_formatado) {
        return this.resumoReceber.atrasados_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => this.listStatus(item) === 'ATRASADO')
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
    previsao30Dashboard() {
      if (this.resumoReceber && this.resumoReceber.previsao_proximos_dias_formatado) {
        return this.resumoReceber.previsao_proximos_dias_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => {
            const diff = this.diffDate(item.data_vencimento)
            return !item.pago && diff >= 0 && diff <= 30
          })
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
  },

  watch: {
    currentPage() {
      this.listando()
    },
    filter() {
      clearTimeout(this.filterDebounce)
      this.filterDebounce = setTimeout(() => {
        this.resetPageAndList()
      }, 500)
    },
    listStatusFilter() {
      this.resetPageAndList()
    },
    filterStartDate() {
      this.resetPageAndList()
    },
    filterEndDate() {
      this.resetPageAndList()
    },
    'contaAReceberEdit.desconto_taxa': function () {
      if (this.contaAReceberEdit.pago) this.calcularValorTotal()
    },
    'contaAReceberEdit.juro_multa': function () {
      if (this.contaAReceberEdit.pago) this.calcularValorTotal()
    },
    'contaAReceberEdit.valor': function () {
      if (this.contaAReceberEdit.pago) this.calcularValorTotal()
    },
    'contaAReceberEdit.pago': function () {
      this.contaAReceberEdit.valor_final = ''
      if (this.contaAReceberEdit.pago) {
        this.contaAReceberEdit.valor_final = this.contaAReceberEdit.valor
      }
    },
    mostraForm() {
      if (this.mostraForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
    this.handleGet()
  },
  methods: {
    calcularValorTotal() {
      var valor = currencyFormatter.unformat(this.contaAReceberEdit.valor, {
        locale: 'pt-BR',
        code: 'BRL',
      })
      var taxa = currencyFormatter.unformat(
        this.contaAReceberEdit.desconto_taxa,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
      var multa = currencyFormatter.unformat(
        this.contaAReceberEdit.juro_multa,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
      var valorCalculado = valor - taxa - multa

      this.contaAReceberEdit.valor_final = currencyFormatter.format(
        valorCalculado,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      CategoriaConta.listar(token)
        .then((resposta) => {
          this.categoriasConta = resposta.data.categorias
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
      CentroCusto.listar(token)
        .then((resposta) => {
          this.centroCusto = resposta.data.centros
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
      TipoConta.listar(token)
        .then((resposta) => {
          this.isLoading = false
          this.tiposConta = resposta.data.tipoContas
        })
        .catch((error) => {
          this.isLoading = false
        })
      produtor
        .listar(token, this.filter)
        .then((resposta) => {
          this.produtores = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.produtores = []
          this.isLoading = false
        })
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    formatPreviewDate(date) {
      if (!date) return '--/--/----'
      const formattedDate = moment.utc(date).format('DD/MM/YYYY')
      return formattedDate !== 'Invalid date' ? formattedDate : date
    },
    getOptionLabel(options, key, value, label, fallback) {
      const selectedOption = options.find(
        (item) => item[key] === value || String(this.getPersonId(item)) === String(value)
      )
      return selectedOption ? selectedOption[label] : fallback
    },
    getPersonId(item) {
      if (!item || typeof item !== 'object') return item
      return item.id_produtor_rural || item.id_cliente || item.id
    },
    parseMoney(value) {
      if (!value) return 0
      if (typeof value === 'number') return value
      return currencyFormatter.unformat(value, {
        locale: 'pt-BR',
        code: 'BRL',
      })
    },
    formatMoney(value) {
      return currencyFormatter.format(value || 0, {
        locale: 'pt-BR',
        code: 'BRL',
      })
    },
    historyStatus(item) {
      if (item.pago) return 'PAGO'
      if (this.diffDate(item.data_vencimento) < 0) return 'ATRASADO'
      return 'ABERTO'
    },
    listStatus(item) {
      if (item.status) return String(item.status).toUpperCase()
      return this.historyStatus(item)
    },
    statusLabel(item) {
      const status = this.listStatus(item).toLowerCase()
      if (status === 'recebido' || status === 'pago') return 'Recebido'
      if (status === 'atrasado') return 'Atrasado'
      if (status === 'cancelado') return 'Cancelado'
      return 'Pendente'
    },
    listStatusClass(item) {
      return `receivable-list-status is-${this.listStatus(item).toLowerCase()}`
    },
    clientInitials(item) {
      const name = this.clientName(item)
      return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0))
        .join('')
        .toUpperCase()
    },
    clientCnpj(item) {
      return item.cliente_documento || item.cnpj || item.cpf_cnpj || 'Documento nao informado'
    },
    clientName(item) {
      return item.cliente_nome || item.cliente || 'Cliente nao informado'
    },
    itemValue(item) {
      return item.valor_formatado || this.formatMoney(this.parseMoney(item.valor))
    },
    itemFinalValue(item) {
      return item.valor_final_formatado || this.itemValue(item)
    },
    itemNumber(item) {
      if (item.valor_formatado) return this.parseMoney(item.valor_formatado)
      return this.parseMoney(item.valor)
    },
    itemFinalNumber(item) {
      if (item.valor_final_formatado) return this.parseMoney(item.valor_final_formatado)
      return this.itemNumber(item)
    },
    dueDescription(item) {
      const diff = this.diffDate(item.data_vencimento)
      if (item.pago) return this.formatPreviewDate(item.data_vencimento)
      if (diff === 0) return 'Vence hoje'
      if (diff > 0) return `Em ${diff} ${diff === 1 ? 'dia' : 'dias'}`
      return `Atrasado ${Math.abs(diff)} ${Math.abs(diff) === 1 ? 'dia' : 'dias'}`
    },
    historyStatusClass(item) {
      return `history-status is-${this.historyStatus(item).toLowerCase()}`
    },
    openHistory() {
      this.showHistory = true
    },
    closeHistory() {
      this.showHistory = false
    },
    setRecurrence(value) {
      if (value === 'nao') {
        this.$set(this.contaAReceberEdit, 'repetir', false)
        return
      }
      this.$set(this.contaAReceberEdit, 'repetir', true)
      this.$set(this.contaAReceberEdit, 'frquencySelected', value)
    },
    isRecurrence(value) {
      if (value === 'nao') return !this.contaAReceberEdit.repetir
      return (
        this.contaAReceberEdit.repetir &&
        this.contaAReceberEdit.frquencySelected === value
      )
    },
    setStatus(value) {
      this.$set(this.contaAReceberEdit, 'pago', value === 'recebido')
      this.$set(
        this.contaAReceberEdit,
        'status',
        value === 'recebido' ? 'recebido' : 'pendente'
      )
    },
    resetContaAReceber() {
      this.contaAReceberEdit = {
        frquencySelected: 'mensalmente',
        vezes: '12',
        repetir: false,
        pago: false,
      }
    },
    diffDate(date) {
      var given = moment.utc(date, 'YYYY-MM-DD')
      var current = moment.utc().startOf('day')
      return moment.duration(given.diff(current)).asDays()
    },
    resetPageAndList() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
        return
      }
      this.listando()
    },
    goToShortcut(path) {
      if (this.$route.path === path) return
      this.$router.push(path).catch(() => {})
    },
    openQuickCreate(type) {
      this.quickModalType = type
      if (type === 'client') {
        this.quickClient = {
          nome: '',
          cpf_cnpj: '',
          telefone: '',
          email: '',
          propriedade: '',
        }
      }
      if (type === 'category') {
        this.quickCategory = {
          descricao: '',
          ativo: true,
        }
      }
      if (type === 'cost-center') {
        this.quickCostCenter = {
          descricao: '',
          ativo: true,
        }
      }
      this.$bvModal.show('quick-create-receivable')
    },
    closeQuickCreate() {
      this.$bvModal.hide('quick-create-receivable')
      this.quickModalType = ''
    },
    normalizeCreatedItem(response, list, labelKey, fallbackLabel) {
      const data = response && response.data ? response.data : {}
      const direct =
        data.data ||
        data.produtor ||
        data.produtorRural ||
        data.categoria ||
        data.centro ||
        data.centroCusto ||
        data.item ||
        data
      if (direct && (direct.id || direct.id_produtor_rural || direct.id_cliente)) return direct
      const label = String(fallbackLabel || '').trim().toLowerCase()
      return (Array.isArray(list) ? list : []).find(
        (item) => String(item[labelKey] || '').trim().toLowerCase() === label
      )
    },
    refreshClients() {
      const token = this.$store.state.auth.currentUser.token
      return produtor.listar(token, 1, 100).then((response) => {
        this.produtores = response.data.data || []
        return this.produtores
      })
    },
    handleQuickClientSaved(payload) {
      this.refreshClients()
        .then((items) => {
          const created = this.normalizeCreatedItem(
            payload && payload.response,
            items,
            'nome',
            payload && payload.produtor ? payload.produtor.nome : this.quickClient.nome
          )
          if (created) this.$set(this.contaAReceberEdit, 'id_cliente', this.getPersonId(created))
          this.closeQuickCreate()
        })
        .catch((error) => this.showApiError(error))
    },
    refreshCategories() {
      const token = this.$store.state.auth.currentUser.token
      return CategoriaConta.listar(token).then((response) => {
        this.categoriasConta = response.data.categorias || []
        return this.categoriasConta
      })
    },
    refreshCostCenters() {
      const token = this.$store.state.auth.currentUser.token
      return CentroCusto.listar(token).then((response) => {
        this.centroCusto = response.data.centros || []
        return this.centroCusto
      })
    },
    saveQuickCreate() {
      const token = this.$store.state.auth.currentUser.token
      if (this.quickModalType === 'client') {
        if (!this.quickClient.nome) {
          this.$bvToast.toast('Informe o nome do cliente.', {
            variant: 'info',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }
        this.isLoading = true
        produtor
          .salvar(token, {
            ...this.quickClient,
            propriedade: this.quickClient.propriedade || this.quickClient.nome,
          })
          .then((response) => this.refreshClients().then((items) => ({ response, items })))
          .then(({ response, items }) => {
            const created = this.normalizeCreatedItem(response, items, 'nome', this.quickClient.nome)
            if (created) this.$set(this.contaAReceberEdit, 'id_cliente', this.getPersonId(created))
            this.$bvToast.toast('Cliente cadastrado e selecionado.', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.closeQuickCreate()
          })
          .catch((error) => this.showApiError(error))
          .finally(() => {
            this.isLoading = false
          })
        return
      }

      if (this.quickModalType === 'category') {
        if (!this.quickCategory.descricao) {
          this.$bvToast.toast('Informe a descrição da categoria.', {
            variant: 'info',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }
        this.isLoading = true
        CategoriaConta.salvar(token, this.quickCategory)
          .then((response) => this.refreshCategories().then((items) => ({ response, items })))
          .then(({ response, items }) => {
            const created = this.normalizeCreatedItem(response, items, 'descricao', this.quickCategory.descricao)
            if (created) this.$set(this.contaAReceberEdit, 'id_categoria', created.id)
            this.$bvToast.toast('Categoria cadastrada e selecionada.', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.closeQuickCreate()
          })
          .catch((error) => this.showApiError(error))
          .finally(() => {
            this.isLoading = false
          })
        return
      }

      if (this.quickModalType === 'cost-center') {
        if (!this.quickCostCenter.descricao) {
          this.$bvToast.toast('Informe a descrição do centro de custo.', {
            variant: 'info',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }
        this.isLoading = true
        CentroCusto.salvar(token, this.quickCostCenter)
          .then((response) => this.refreshCostCenters().then((items) => ({ response, items })))
          .then(({ response, items }) => {
            const created = this.normalizeCreatedItem(response, items, 'descricao', this.quickCostCenter.descricao)
            if (created) this.$set(this.contaAReceberEdit, 'id_centro_custo', created.id)
            this.$bvToast.toast('Centro de custo cadastrado e selecionado.', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.closeQuickCreate()
          })
          .catch((error) => this.showApiError(error))
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    toggleAdvancedFilters() {
      this.showAdvancedFilters = !this.showAdvancedFilters
    },
    applyAdvancedFilters() {
      this.resetPageAndList()
      this.showAdvancedFilters = false
    },
    clearAdvancedFilters() {
      this.filterStartDate = ''
      this.filterEndDate = ''
      this.listStatusFilter = 'todos'
      this.filter = ''
      this.resetPageAndList()
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      const skip = (this.currentPage - 1) * this.perPage
      const filters = {
        skip,
        offset: skip,
        take: this.perPage,
        limit: this.perPage,
        sortBy: 'data_vencimento',
        sortOrder: 'ASC',
      }
      if (this.filter) filters.search = this.filter
      if (this.listStatusFilter !== 'todos') filters.status = this.listStatusFilter
      if (this.filterStartDate) filters.data_inicio = this.filterStartDate
      if (this.filterEndDate) filters.data_fim = this.filterEndDate
      this.isLoading = true
      ContaPagarReceber.listReceivables(token, filters)
        .then((resposta) => {
          this.contasAreceber = resposta.data.contas || []
          this.rows = resposta.data.total || resposta.data.count || 0
          if (resposta.data.page) {
            this.perPage = resposta.data.page.take || this.perPage
          }
          this.isLoading = false
        })
        .catch((error) => {
          this.showApiError(error)
          this.isLoading = false
        })
      ContaPagarReceber.getReceivableSummary(token, { dias: 30 })
        .then((resposta) => {
          this.resumoReceber = resposta.data.resumo || null
        })
        .catch(() => {
          this.resumoReceber = null
        })
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.mostraForm = false
        this.showHistory = false
        if (!this.contaAReceberEdit.id) this.resetContaAReceber()
      } else {
        this.showHistory = false
        this.mostraForm = true
        this.listando()
      }
    },
    salvarENova() {
      this.salvar(true)
    },
    editRegister(categoriaConta) {
      this.contaAReceberEdit = { ...categoriaConta }
      this.showHistory = false
      this.mostraForm = false
    },
    apiErrorMessage(erro) {
      const data = erro && erro.response ? erro.response.data : null
      if (data && data.aviso && data.aviso.mensagem) return data.aviso.mensagem
      if (data && data.mensagem) return data.mensagem
      if (data && Array.isArray(data.message)) return data.message.join(', ')
      if (data && data.message) return data.message
      return erro && erro.message ? erro.message : 'Erro inesperado'
    },
    showApiError(erro) {
      this.$bvToast.toast(this.apiErrorMessage(erro), {
        variant: 'danger',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    buildReceivablePayload() {
      const conta = { ...this.contaAReceberEdit }
      conta.id_cliente = this.getPersonId(conta.id_cliente)
      const moneyFields = ['valor', 'valor_final', 'desconto_taxa', 'juro_multa']
      moneyFields.forEach((field) => {
        if (conta[field] !== undefined && conta[field] !== null && conta[field] !== '') {
          conta[field] = this.parseMoney(conta[field])
        }
      })
      conta.tipo_operacao = 'RECEBER'
      conta.status = conta.pago ? 'recebido' : conta.status || 'pendente'
      if (conta.pago && !conta.data_recebimento) {
        conta.data_recebimento = moment().format('YYYY-MM-DD')
      }
      return conta
    },
    salvar(resetAfterSave = false) {
      const token = this.$store.state.auth.currentUser.token
      const contaAReceber = this.buildReceivablePayload()
      if (contaAReceber.id) {
        this.isLoading = true
        return ContaPagarReceber.updateReceivable(token, contaAReceber.id, contaAReceber)
          .then((resposta) => {
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            if (resetAfterSave) this.resetContaAReceber()
            this.listando()
            this.isLoading = false
          })
          .catch((erro) => {
            this.showApiError(erro)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.isLoading = true
        return ContaPagarReceber.createReceivable(token, contaAReceber)
          .then((resposta) => {
            this.isLoading = false
            this.$bvToast.toast('Salvo com sucesso!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            if (resetAfterSave) this.resetContaAReceber()
            else this.cadastra()
          })
          .catch((erro) => {
            this.showApiError(erro)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idDelete = id
    },
    handleDelete() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      ContaPagarReceber.deleteAccount(token, this.idDelete)
        .then((reposta) => {
          this.$bvToast.toast('Conta excluída', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isLoading = false
          this.listando()
        })
        .catch((err) => {
          this.$bvModal.hide('modal-delete')
          this.isLoading = false
          this.showApiError(err)
        })
      this.idDelete = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-7 mb-2">
            <div class="titulo">
              <i :class="mostraForm ? 'uil uil-money-withdraw' : 'uil uil-import'"></i>
              {{ mostraForm ? 'Contas a Receber' : 'Nova Conta a Receber' }}
            </div>
            <div class="subTitulo">
              {{
                mostraForm
                  ? 'Gerencie e acompanhe todas as cobranças pendentes e recebidas.'
                  : 'Cadastre uma cobrança, venda ou serviço prestado.'
              }}
            </div>
          </div>
          <div class="col-md-5">
            <div class="receivable-page-actions">
              <button
                v-if="mostraForm"
                :class="['btn btn-light', { active: showAdvancedFilters }]"
                type="button"
                @click="toggleAdvancedFilters"
              >
                <i class="uil uil-filter"></i>
                Filtros Avançados
              </button>
              <button v-if="mostraForm" class="btn btn-light" type="button">
                <i class="uil uil-export"></i>
                Exportar
              </button>
              <button
                v-if="!mostraForm"
                class="btn btn-light"
                type="button"
                @click="openHistory"
              >
                <i class="uil uil-clock"></i>
                Histórico
              </button>
              <button
                v-if="!mostraForm"
                class="btn btn-light"
                type="button"
                @click="salvarENova"
              >
                <i class="uil uil-plus"></i>
                Salvar e nova
              </button>
              <button
                v-if="!mostraForm"
                class="btn btn-webreceita"
                type="button"
                @click="salvar"
              >
                <i class="uil uil-save"></i>
                Salvar
              </button>
              <button class="btn btn-webreceita" @click="cadastra">
                <i v-if="mostraForm" class="uil uil-plus"></i>
                <span v-if="mostraForm">Nova Conta</span>
                <span v-else>Visualizar Contas a Receber</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div v-if="mostraForm" class="receivable-dashboard">
        <div class="receivable-kpi-grid">
          <article class="receivable-kpi is-positive">
            <span>Total a receber</span>
            <strong>{{ totalReceberDashboard }}</strong>
            <small><i class="uil uil-arrow-growth"></i> +12.5% vs mês ant.</small>
          </article>
          <article class="receivable-kpi is-positive">
            <span>Vencendo hoje</span>
            <strong>{{ vencendoHojeDashboard }}</strong>
            <small>{{ vencendoHojeCount }} faturas pendentes</small>
          </article>
          <article class="receivable-kpi is-danger">
            <span>Atrasados</span>
            <strong>{{ atrasadosDashboard }}</strong>
            <small>Atenção necessária</small>
          </article>
          <article class="receivable-kpi">
            <span>Previsão 30 dias</span>
            <strong>{{ previsao30Dashboard }}</strong>
            <small>Fluxo de caixa saudável</small>
          </article>
        </div>

        <section class="receivable-list-card">
          <div class="receivable-table-wrap">
            <table class="receivable-table">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Descrição</th>
                  <th>Vencimento</th>
                  <th>Valor</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in filteredReceivableRows" :key="item.id">
                  <td>
                    <div class="receivable-client-cell">
                      <span class="client-avatar">{{ clientInitials(item) }}</span>
                      <div>
                        <strong>{{ clientName(item) }}</strong>
                        <span>CNPJ:</span>
                        <small>{{ clientCnpj(item) }}</small>
                      </div>
                    </div>
                  </td>
                  <td>{{ item.descricao || 'Conta a receber' }}</td>
                  <td>
                    <strong :class="{ 'is-danger-text': listStatus(item) === 'ATRASADO' }">
                      {{ formatPreviewDate(item.data_vencimento) }}
                    </strong>
                    <span :class="{ 'is-danger-text': listStatus(item) === 'ATRASADO' }">
                      {{ dueDescription(item) }}
                    </span>
                  </td>
                  <td>
                    <strong>{{ itemValue(item) }}</strong>
                  </td>
                  <td>
                    <span :class="listStatusClass(item)">
                      {{ statusLabel(item) }}
                    </span>
                  </td>
                  <td>
                    <div class="receivable-row-actions">
                      <button
                        v-b-tooltip.hover
                        title="Editar"
                        type="button"
                        @click="editRegister(item)"
                      >
                        <i class="uil uil-edit"></i>
                      </button>
                      <button
                        v-b-tooltip.hover
                        title="Deletar"
                        type="button"
                        @click="modalDelete(item.id)"
                      >
                        <i class="uil uil-trash-alt"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!filteredReceivableRows.length">
                  <td colspan="6" class="receivable-empty">
                    Nenhuma conta a receber encontrada.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="receivable-list-footer">
            <span>Exibindo {{ filteredReceivableRows.length }} de {{ rows }} resultados</span>
            <b-pagination
              v-model="currentPage"
              size="sm"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </section>

        <div class="receivable-dashboard-bottom">
          <section class="receivable-insight-card">
            <span class="insight-icon"><i class="uil uil-lightbulb-alt"></i></span>
            <div>
              <h3>Dica de Gestão</h3>
              <p>
                Contas recorrentes e lembretes automáticos ajudam a manter seu fluxo
                de caixa saudável. Configure o envio automático de boletos e
                notificações de vencimento.
              </p>
              <button type="button">
                Configurar automações
                <i class="uil uil-arrow-right"></i>
              </button>
            </div>
          </section>
          <section class="receivable-shortcuts-panel">
            <h3><i class="uil uil-bolt"></i> Atalhos Rápidos</h3>
            <button type="button" @click="openQuickCreate('client')">+ Novo cliente</button>
            <button type="button" @click="openQuickCreate('category')">+ Nova categoria</button>
            <button type="button" @click="goToShortcut('/financeiro/conciliacao-bancaria')">+ Conciliação bancária</button>
          </section>
        </div>
      </div>

      <div v-else class="receivable-create">
        <section v-if="showHistory" class="history-screen">
          <div class="history-topbar">
            <div>
              <div class="history-breadcrumb">
                Clientes <i class="uil uil-angle-right"></i>
                {{ resumoCliente }} <i class="uil uil-angle-right"></i>
                Histórico
              </div>
              <h2>Histórico de Contas a Receber</h2>
            </div>
            <div class="history-actions">
              <button class="btn btn-light" type="button" @click="closeHistory">
                <i class="uil uil-arrow-left"></i>
                Voltar
              </button>
              <button class="btn btn-light" type="button">
                <i class="uil uil-share-alt"></i>
                Compartilhar
              </button>
              <button class="btn btn-webreceita" type="button">
                <i class="uil uil-export"></i>
                Exportar Histórico
              </button>
            </div>
          </div>

          <div class="history-client-card">
            <div class="history-client-main">
              <span class="history-company-icon">
                <i class="uil uil-building"></i>
              </span>
              <div>
                <strong>{{ resumoCliente }}</strong>
                <span>CNPJ: {{ historyClient.cnpj || '12.345.678/0001-99' }}</span>
                <small>
                  <i class="uil uil-envelope"></i>
                  {{ historyClient.email || 'contato@cliente.com.br' }}
                  <i class="uil uil-phone ml-2"></i>
                  {{ historyClient.telefone || '(11) 4002-8922' }}
                </small>
              </div>
            </div>
            <div class="history-client-metrics">
              <div>
                <span>Saúde financeira</span>
                <strong class="is-good">Excelente</strong>
                <small>Baixo risco de inadimplência</small>
              </div>
              <div>
                <span>Atraso médio</span>
                <strong>2.4 dias</strong>
                <small>Últimos 12 meses</small>
              </div>
              <div>
                <span>Último pagamento</span>
                <strong>{{ historyLastPayment }}</strong>
                <small>{{ historyTotalRecebido }}</small>
              </div>
            </div>
          </div>

          <div class="history-kpis">
            <article>
              <span><i class="uil uil-invoice"></i> +4.2%</span>
              <small>Total a Receber</small>
              <strong>{{ historyTotalReceber }}</strong>
            </article>
            <article>
              <span class="is-positive"><i class="uil uil-check-circle"></i> +12.8%</span>
              <small>Total Recebido</small>
              <strong>{{ historyTotalRecebido }}</strong>
            </article>
            <article>
              <span class="is-negative"><i class="uil uil-exclamation-triangle"></i> -2.1%</span>
              <small>Em Atraso</small>
              <strong class="is-danger">{{ historyTotalAtraso }}</strong>
            </article>
            <article>
              <span><i class="uil uil-wallet"></i> Limit 50k</span>
              <small>Crédito Disponível</small>
              <strong>R$ 15.000,00</strong>
            </article>
          </div>

          <div class="history-filters">
            <div class="history-search">
              <i class="uil uil-search"></i>
              <input type="text" placeholder="Buscar por número da fatura ou serviço" />
            </div>
            <input type="text" placeholder="dd/mm/aaaa" />
            <span>até</span>
            <input type="text" placeholder="dd/mm/aaaa" />
            <select>
              <option>Todos Status</option>
              <option>Pendente</option>
              <option>Recebido</option>
              <option>Atrasado</option>
              <option>Cancelado</option>
            </select>
            <button type="button"><i class="uil uil-filter"></i></button>
          </div>

          <section class="history-table-card">
            <div class="history-table-head">
              <h3><i class="uil uil-list-ul"></i> Lançamentos Recentes</h3>
              <span>Exibindo {{ historyRows.length }} de {{ rows }} resultados</span>
            </div>
            <div class="history-table-wrap">
              <table class="history-table">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Descrição</th>
                    <th>Valor Original</th>
                    <th>Saldo Devido</th>
                    <th>Vencimento</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in historyRows" :key="item.id">
                    <td>{{ formatPreviewDate(item.data_competencia) }}</td>
                    <td>
                      <strong>Fatura #{{ item.id }}</strong>
                      <span>{{ item.descricao || 'Conta a receber' }}</span>
                    </td>
                    <td>{{ itemValue(item) }}</td>
                    <td :class="{ 'is-danger': historyStatus(item) === 'ATRASADO' }">
                      {{ item.pago ? 'R$ 0,00' : itemFinalValue(item) }}
                    </td>
                    <td>{{ formatPreviewDate(item.data_vencimento) }}</td>
                    <td>
                      <span :class="historyStatusClass(item)">
                        {{ statusLabel(item) }}
                      </span>
                    </td>
                    <td>
                      <button type="button" class="history-more">
                        <i class="uil uil-ellipsis-v"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!historyRows.length">
                    <td colspan="7" class="history-empty">
                      Nenhum lançamento encontrado para este cliente.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="history-footer">
              <span>Linhas por página: 10</span>
              <span>1-{{ historyRows.length }} de {{ historyRows.length }}</span>
            </div>
          </section>

          <div class="history-send-actions">
            <button class="btn btn-webreceita" type="button">
              <i class="uil uil-whatsapp"></i>
              Enviar Extrato via WhatsApp
            </button>
            <button class="btn btn-light" type="button">
              <i class="uil uil-envelope"></i>
              Enviar por E-mail
            </button>
          </div>
        </section>

        <b-form v-else>
          <div class="receivable-grid">
            <main class="receivable-main">
              <section class="receivable-section">
                <h2><i class="uil uil-clipboard-notes"></i> 1. Informações Gerais</h2>
                <b-form-group label="Descrição *">
                  <b-form-input
                    v-model="contaAReceberEdit.descricao"
                    placeholder="Ex.: Venda de defensivos agrícolas"
                  />
                </b-form-group>
                <div class="receivable-form-grid two-cols">
                  <b-form-group label="Cliente *">
                    <div class="input-with-action">
                      <v-select
                        class="style-select"
                        label="nome"
                        :options="produtores"
                        :reduce="getPersonId"
                        v-model="contaAReceberEdit.id_cliente"
                        placeholder="Digite para buscar o cliente..."
                        :dense="true"
                      ></v-select>
                      <button class="btn btn-light" type="button" @click="openQuickCreate('client')">
                        <i class="uil uil-plus"></i>
                        Novo
                      </button>
                    </div>
                  </b-form-group>
                  <b-form-group label="Categoria *">
                    <v-select
                      class="style-select"
                      label="descricao"
                      :options="categoriasConta"
                      :reduce="(item) => item.id"
                      v-model="contaAReceberEdit.id_categoria"
                      placeholder="Selecione a categoria"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                  <b-form-group label="Centro de Custo">
                    <v-select
                      class="style-select"
                      label="descricao"
                      :options="centroCusto"
                      :reduce="(item) => item.id"
                      v-model="contaAReceberEdit.id_centro_custo"
                      placeholder="Selecione o centro de custo"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                  <b-form-group label="Tags">
                    <b-form-input placeholder="Adicionar tag" />
                  </b-form-group>
                </div>
              </section>

              <section class="receivable-section">
                <h2><i class="uil uil-money-bill"></i> 2. Financeiro</h2>
                <div class="receivable-form-grid two-cols">
                  <b-form-group label="Competência *">
                    <b-form-datepicker
                      id="datepicker-competencia"
                      v-model="contaAReceberEdit.data_competencia"
                      placeholder=""
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                  </b-form-group>
                  <b-form-group label="Vencimento *">
                    <b-form-datepicker
                      id="datepicker-vencimento"
                      v-model="contaAReceberEdit.data_vencimento"
                      placeholder=""
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                    <span v-if="diasAteVencimento" class="field-hint">{{ diasAteVencimento }}</span>
                  </b-form-group>
                  <b-form-group label="Conta Bancária *">
                    <v-select
                      class="style-select"
                      label="tipo"
                      :options="tiposConta"
                      :reduce="(item) => item.id"
                      v-model="contaAReceberEdit.id_tipo_conta"
                      placeholder="Selecione a conta"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                  <b-form-group label="Valor *">
                    <div class="value-row">
                      <b-form-input
                        v-model.lazy="contaAReceberEdit.valor"
                        v-money="money"
                      />
                      <button class="btn btn-light" type="button">
                        <i class="uil uil-plus"></i>
                        Juros/Multa
                      </button>
                    </div>
                  </b-form-group>
                </div>
                <div class="receivable-form-grid four-cols" v-show="contaAReceberEdit.pago">
                  <b-form-group label="Data de recebimento">
                    <b-form-datepicker
                      id="datepicker-recebimento"
                      v-model="contaAReceberEdit.data_recebimento"
                      placeholder=""
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                  </b-form-group>
                  <b-form-group label="Desconto / Taxas">
                    <b-form-input v-model.lazy="contaAReceberEdit.desconto_taxa" v-money="money" />
                  </b-form-group>
                  <b-form-group label="Juros / Multa">
                    <b-form-input v-model.lazy="contaAReceberEdit.juro_multa" v-money="money" />
                  </b-form-group>
                  <b-form-group label="Valor Final">
                    <b-form-input disabled class="bg-light" v-model="contaAReceberEdit.valor_final" />
                  </b-form-group>
                </div>
              </section>

              <div class="receivable-split">
                <section class="receivable-section">
                  <h2><i class="uil uil-sync"></i> 3. Recorrência</h2>
                  <div class="radio-list">
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('nao') }]"
                      @click="setRecurrence('nao')"
                    >
                      <span></span> Não repetir
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('mensalmente') }]"
                      @click="setRecurrence('mensalmente')"
                    >
                      <span></span> Mensal
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('semanalmente') }]"
                      @click="setRecurrence('semanalmente')"
                    >
                      <span></span> Semanal
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('quinzenalmente') }]"
                      @click="setRecurrence('quinzenalmente')"
                    >
                      <span></span> Quinzenal
                    </button>
                  </div>
                  <div class="recurrence-box" v-show="contaAReceberEdit.repetir">
                    <label>Repetir por</label>
                    <div class="repeat-inline">
                      <b-form-select
                        v-model="contaAReceberEdit.vezes"
                        :options="numberOccurrences"
                      ></b-form-select>
                      <span>vezes</span>
                    </div>
                    <p>Próximo vencimento: {{ proximoVencimento }}</p>
                  </div>
                </section>

                <section class="receivable-section">
                  <h2><i class="uil uil-flag"></i> 4. Status</h2>
                  <div class="radio-list">
                    <button
                      type="button"
                      :class="['radio-row', { active: !contaAReceberEdit.pago }]"
                      @click="setStatus('aberto')"
                    >
                      <span></span> Pendente
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: contaAReceberEdit.pago }]"
                      @click="setStatus('recebido')"
                    >
                      <span></span> Recebido
                    </button>
                    <button type="button" class="radio-row muted">
                      <span></span> Cancelado
                    </button>
                    <button type="button" class="radio-row muted">
                      <span></span> Atrasado
                    </button>
                  </div>
                </section>
              </div>

              <section class="receivable-section">
                <h2><i class="uil uil-comment-alt-lines"></i> 5. Observações</h2>
                <b-form-textarea
                  id="textarea"
                  v-model="contaAReceberEdit.obs"
                  placeholder="Informações adicionais, instruções, observações..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </section>

              <div class="receivable-split">
                <section class="receivable-section">
                  <h2><i class="uil uil-paperclip"></i> Anexos</h2>
                  <label class="upload-drop">
                    <i class="uil uil-cloud-upload"></i>
                    <span>Arraste arquivos aqui ou clique para selecionar</span>
                    <small>PDF, JPG, PNG até 10MB cada</small>
                    <input type="file" multiple />
                  </label>
                </section>

                <section class="receivable-section">
                  <h2><i class="uil uil-message"></i> Cobrança automática</h2>
                  <p class="section-subtitle">Enviar lembretes automáticos desta cobrança</p>
                  <div class="reminder-options">
                    <b-form-checkbox checked>WhatsApp</b-form-checkbox>
                    <b-form-checkbox checked>E-mail</b-form-checkbox>
                  </div>
                  <div class="reminder-row">
                    <label>Enviar lembrete</label>
                    <b-form-select
                      :options="[
                        { value: '3', text: '3 dias antes do vencimento' },
                        { value: '5', text: '5 dias antes do vencimento' },
                        { value: '7', text: '7 dias antes do vencimento' },
                      ]"
                      value="3"
                    ></b-form-select>
                  </div>
                </section>
              </div>
            </main>

            <aside class="receivable-aside">
              <section class="receivable-section summary-card">
                <h2><i class="uil uil-clipboard-notes"></i> Resumo da Cobrança</h2>
                <div class="summary-item">
                  <span>Cliente</span>
                  <strong>{{ resumoCliente }}</strong>
                  <button type="button">Ver detalhes</button>
                </div>
                <div class="summary-item">
                  <span>Descrição</span>
                  <strong>{{ contaAReceberEdit.descricao || 'Descrição não informada' }}</strong>
                </div>
                <div class="summary-item">
                  <span>Valor</span>
                  <strong class="summary-value">{{ resumoValor }}</strong>
                </div>
                <div class="summary-dates">
                  <div>
                    <span>Vencimento</span>
                    <strong><i class="uil uil-calendar-alt"></i> {{ resumoVencimento }}</strong>
                    <small v-if="diasAteVencimento">{{ diasAteVencimento }}</small>
                  </div>
                  <div>
                    <span>Competência</span>
                    <strong><i class="uil uil-calendar-alt"></i> {{ resumoCompetencia }}</strong>
                  </div>
                </div>
                <div class="summary-item">
                  <span>Conta Bancária</span>
                  <strong>{{ resumoConta }}</strong>
                </div>
                <div class="summary-item">
                  <span>Status</span>
                  <b-badge :variant="contaAReceberEdit.pago ? 'primary' : 'success'">
                    {{ contaAReceberEdit.pago ? 'Recebido' : 'Pendente' }}
                  </b-badge>
                </div>
                <div class="summary-item">
                  <span>Recorrência</span>
                  <strong>{{ resumoRecorrencia }}</strong>
                </div>
                <div class="summary-item">
                  <span>Categoria</span>
                  <strong>{{ resumoCategoria }}</strong>
                </div>
              </section>

              <section class="receivable-tip">
                <h3><i class="uil uil-lightbulb-alt"></i> Dica</h3>
                <p>Contas recorrentes e lembretes automáticos ajudam a manter seu fluxo de caixa saudável.</p>
              </section>

              <section class="receivable-section shortcuts-card">
                <h2><i class="uil uil-bolt"></i> Atalhos</h2>
                <button type="button" @click="openQuickCreate('client')"><i class="uil uil-plus"></i> Novo cliente</button>
                <button type="button" @click="openQuickCreate('category')"><i class="uil uil-plus"></i> Nova categoria</button>
                <button type="button" @click="openQuickCreate('cost-center')"><i class="uil uil-plus"></i> Novo centro de custo</button>
              </section>
            </aside>
          </div>
        </b-form>
      </div>
    </div>

    <div
      v-if="showAdvancedFilters"
      class="receivable-filter-overlay"
      @click="toggleAdvancedFilters"
    ></div>
    <aside v-if="showAdvancedFilters" class="receivable-filter-drawer" aria-label="Filtros">
      <header class="receivable-filter-head">
        <div>
          <strong>Filtros avançados</strong>
          <span>Refine as contas a receber exibidas na lista.</span>
        </div>
        <button
          class="receivable-filter-close"
          type="button"
          aria-label="Fechar filtros"
          @click="toggleAdvancedFilters"
        >
          <i class="uil uil-times"></i>
        </button>
      </header>
      <div class="receivable-filter-body">
        <label class="receivable-filter-field">
          Busca
          <div class="receivable-search">
            <i class="uil uil-search"></i>
            <input v-model="filter" type="text" placeholder="Cliente, descrição ou valor" />
          </div>
        </label>
        <label class="receivable-filter-field">
          Status
          <select v-model="listStatusFilter">
            <option value="todos">Todos os Status</option>
            <option value="pendente">Pendente</option>
            <option value="atrasado">Atrasado</option>
            <option value="recebido">Recebido</option>
            <option value="cancelado">Cancelado</option>
          </select>
        </label>
        <label class="receivable-filter-field">
          Data inicial
          <input v-model="filterStartDate" type="date" />
        </label>
        <label class="receivable-filter-field">
          Data final
          <input v-model="filterEndDate" type="date" />
        </label>
      </div>
      <footer class="receivable-filter-actions">
        <button class="btn btn-light" type="button" @click="clearAdvancedFilters">
          Limpar filtros
        </button>
        <button class="btn btn-primary" type="button" @click="applyAdvancedFilters">
          Aplicar filtros
        </button>
      </footer>
    </aside>

    <b-modal
      id="quick-create-receivable"
      :title="
        quickModalType === 'client'
          ? 'Novo cliente'
          : quickModalType === 'category'
          ? 'Nova categoria'
          : 'Novo centro de custo'
      "
      title-class="font-18"
      hide-footer
      centered
      scrollable
      size="xl"
    >
      <div>
        <form-produtor
          v-if="quickModalType === 'client'"
          :produtor="quickClient"
          @saved="handleQuickClientSaved"
        />

        <div v-if="quickModalType === 'category'" class="quick-create-grid">
          <b-form-group label="Descrição *">
            <b-form-input
              v-model="quickCategory.descricao"
              placeholder="Informe a categoria"
              autofocus
            />
          </b-form-group>
          <b-form-group label="Ativo">
            <b-form-checkbox v-model="quickCategory.ativo" switch>
              Categoria ativa
            </b-form-checkbox>
          </b-form-group>
        </div>

        <div v-if="quickModalType === 'cost-center'" class="quick-create-grid">
          <b-form-group label="Descrição *">
            <b-form-input
              v-model="quickCostCenter.descricao"
              placeholder="Informe o centro de custo"
              autofocus
            />
          </b-form-group>
          <b-form-group label="Ativo">
            <b-form-checkbox v-model="quickCostCenter.ativo" switch>
              Centro de custo ativo
            </b-form-checkbox>
          </b-form-group>
        </div>

        <div v-if="quickModalType !== 'client'" class="quick-create-actions">
          <button class="btn btn-light" type="button" @click="closeQuickCreate">
            Cancelar
          </button>
          <button class="btn btn-webreceita" type="button" @click="saveQuickCreate">
            Salvar e selecionar
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="false"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 24px;
  background-color: #fff;
  padding: 32px;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
  .titulo {
    align-items: center;
    display: flex;
    font-size: 25px;
    gap: 8px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    background-color: #008e75;
    border-color: #008e75;
    color: #fff;
    padding: 9px 24px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.receivable-page-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 600;
    gap: 7px;
    height: 42px;
    justify-content: center;
    margin: 0;
    min-width: 130px;
    padding: 0 18px;
  }

  .btn-light {
    background: #fff;
    border-color: #d8dee8;
    color: #172033;
  }

  .btn-light.active {
    background: #e7f5ef;
    border-color: #008e75;
    color: #008e75;
  }
}

.receivable-dashboard {
  background: #f5f7fb;
  border-radius: 8px;
  display: grid;
  gap: 18px;
  padding: 2px 0 0;
}

.receivable-kpi-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.receivable-kpi {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  display: grid;
  gap: 8px;
  min-height: 118px;
  padding: 18px 20px;

  span {
    color: #172033;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
  }

  strong {
    color: #172033;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.1;
  }

  small {
    color: #536074;
  }

  &.is-positive {
    border-color: rgba(0, 142, 117, 0.65);
  }

  &.is-positive small,
  &.is-positive small i {
    color: #008e75;
  }

  &.is-danger {
    border-color: rgba(220, 53, 69, 0.72);
  }

  &.is-danger strong,
  &.is-danger small {
    color: #dc3545;
  }
}

.receivable-filter-overlay {
  background: rgba(15, 23, 42, 0.38);
  bottom: 0;
  inset: 0;
  left: 0;
  position: fixed !important;
  right: 0;
  top: 0;
  z-index: 3000;
}

.receivable-filter-drawer {
  background: #fff;
  box-shadow: -18px 0 38px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  max-width: 100vw;
  position: fixed !important;
  right: 0;
  top: 0;
  width: 390px;
  z-index: 3010;
}

.receivable-filter-head {
  align-items: flex-start;
  border-bottom: 1px solid #e3e9f2;
  display: flex;
  gap: 14px;
  justify-content: space-between;
  padding: 20px 22px 18px;

  strong {
    color: #172033;
    display: block;
    font-size: 18px;
    font-weight: 800;
  }

  span {
    color: #647084;
    display: block;
    font-size: 13px;
    line-height: 1.4;
    margin-top: 4px;
  }
}

.receivable-filter-close {
  align-items: center;
  background: #f4f7fb;
  border: 1px solid #e0e7f0;
  border-radius: 6px;
  color: #172033;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  min-width: 34px;
  padding: 0;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.receivable-filter-close:hover {
  background: #eaf0f7;
  border-color: #cfd8e5;
}

.receivable-filter-body {
  align-content: start;
  display: grid;
  flex: 1;
  gap: 14px;
  grid-auto-rows: min-content;
  overflow-y: auto;
  padding: 18px 22px 20px;
}

.receivable-filter-field {
  color: #536074;
  display: grid;
  font-size: 12px;
  font-weight: 800;
  gap: 7px;
  margin: 0;

  select,
  input[type='date'] {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 5px;
    color: #172033;
    height: 40px;
    padding: 0 12px;
    width: 100%;
  }
}

.receivable-filter-actions {
  border-top: 1px solid #e3e9f2;
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  padding: 16px 22px;

  .btn {
    margin: 0;
    min-height: 38px;
  }
}

.receivable-search {
  align-items: center;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  display: flex;
  gap: 8px;
  height: 40px;
  min-width: 0;
  padding: 0 12px;
  width: 100%;

  i {
    color: #647084;
  }

  input {
    border: 0;
    color: #172033;
    flex: 1;
    min-width: 0;
    outline: 0;
  }
}

.receivable-list-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  overflow: hidden;
}

.receivable-table-wrap {
  overflow-x: auto;
}

.receivable-table {
  border-collapse: collapse;
  min-width: 880px;
  width: 100%;

  th {
    background: #eef3fb;
    color: #354158;
    font-size: 12px;
    font-weight: 800;
    padding: 14px 18px;
    text-align: left;
    text-transform: uppercase;
  }

  td {
    border-top: 1px solid #e7edf4;
    color: #172033;
    font-size: 13px;
    padding: 16px 18px;
    vertical-align: middle;
  }

  td > strong {
    display: block;
    font-size: 15px;
    font-weight: 800;
  }

  td > span,
  td small {
    color: #647084;
    display: block;
    margin-top: 3px;
  }
}

.receivable-client-cell {
  align-items: center;
  display: flex;
  gap: 12px;

  strong,
  span,
  small {
    display: block;
  }

  strong {
    color: #172033;
    font-weight: 800;
  }

  span,
  small {
    color: #647084;
  }
}

.client-avatar {
  align-items: center;
  background: #dff6f3;
  border-radius: 50%;
  color: #008e75;
  display: inline-flex;
  flex: 0 0 30px;
  font-size: 11px;
  font-weight: 800;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.is-danger-text {
  color: #dc3545 !important;
}

.receivable-list-status {
  border-radius: 999px;
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  padding: 4px 9px;

  &.is-aberto {
    background: #e7f5ef;
    color: #008e75;
  }

  &.is-atrasado {
    background: #ffe9ed;
    color: #dc3545;
  }

  &.is-pago {
    background: #f0f1f2;
    color: #536074;
  }
}

.receivable-row-actions {
  display: flex;
  gap: 6px;

  button {
    align-items: center;
    background: transparent;
    border: 0;
    color: #536074;
    display: inline-flex;
    font-size: 18px;
    height: 30px;
    justify-content: center;
    width: 30px;
  }
}

.receivable-empty {
  color: #647084;
  padding: 28px !important;
  text-align: center;
}

.receivable-list-footer {
  align-items: center;
  border-top: 1px solid #e7edf4;
  color: #536074;
  display: flex;
  justify-content: space-between;
  padding: 16px 18px;

  .pagination {
    margin: 0;
  }
}

.receivable-dashboard-bottom {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 2fr) minmax(260px, 1fr);
}

.receivable-insight-card,
.receivable-shortcuts-panel {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  padding: 18px 20px;
}

.receivable-insight-card {
  display: flex;
  gap: 14px;

  h3,
  p {
    margin: 0;
  }

  h3 {
    color: #172033;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 6px;
  }

  p {
    color: #536074;
    line-height: 1.5;
  }

  button {
    background: transparent;
    border: 0;
    color: #008e75;
    font-weight: 700;
    margin-top: 10px;
    padding: 0;
  }
}

.insight-icon {
  align-items: center;
  background: #e7f5ef;
  border-radius: 50%;
  color: #008e75;
  display: inline-flex;
  flex: 0 0 42px;
  font-size: 22px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.receivable-shortcuts-panel {
  border-color: #cfe2ff;

  h3 {
    align-items: center;
    color: #172033;
    display: flex;
    font-size: 15px;
    font-weight: 800;
    gap: 8px;
    margin: 0 0 12px;
  }

  h3 i {
    color: #0f4aa2;
  }

  button {
    background: transparent;
    border: 0;
    color: #008e75;
    display: block;
    font-weight: 700;
    margin-top: 9px;
    padding: 0;
    text-align: left;
  }
}

.receivable-create {
  color: #172033;
}

.receivable-header {
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: 24px;
}

.receivable-heading {
  align-items: flex-start;
  display: flex;
  gap: 14px;

  h1 {
    color: #172033;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    margin: 0 0 6px;
  }

  p {
    color: #657085;
    font-size: 15px;
    margin: 0;
  }
}

.receivable-heading-icon {
  align-items: center;
  color: #008e75;
  display: inline-flex;
  font-size: 30px;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.receivable-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 600;
    gap: 8px;
    height: 44px;
    justify-content: center;
    margin: 0;
    min-width: 130px;
    padding: 0 22px;
  }

  .btn-webreceita {
    margin: 0;
  }

  .btn-light {
    background: #fff;
    border-color: #d8dee8;
    color: #172033;
  }
}

.receivable-grid {
  align-items: start;
  display: grid;
  gap: 20px;
  grid-template-columns: minmax(0, 1fr) 360px;
}

.receivable-main {
  display: grid;
  gap: 12px;
}

.receivable-aside {
  display: grid;
  gap: 14px;
  position: sticky;
  top: 88px;
}

.receivable-section,
.receivable-tip {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  padding: 18px 20px;

  h2,
  h3 {
    align-items: center;
    color: #172033;
    display: flex;
    font-size: 16px;
    font-weight: 700;
    gap: 10px;
    margin: 0 0 16px;
  }

  h2 i,
  h3 i {
    color: #008e75;
    font-size: 20px;
  }

  label,
  legend {
    color: #172033;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 7px;
  }

  .form-control,
  .custom-select,
  .vs__dropdown-toggle {
    border-color: #d8dee8;
    border-radius: 5px;
    min-height: 36px;
  }
}

.receivable-form-grid {
  display: grid;
  gap: 16px 18px;

  &.two-cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  &.four-cols {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin-top: 12px;
  }
}

.input-with-action,
.value-row {
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) auto;

  .btn {
    align-items: center;
    border-color: #d8dee8;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 600;
    gap: 6px;
    white-space: nowrap;
  }
}

.field-hint {
  color: #6d7686;
  display: block;
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}

.receivable-split {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.radio-list {
  display: grid;
  gap: 8px;
}

.radio-row {
  align-items: center;
  background: transparent;
  border: 0;
  color: #243047;
  display: flex;
  gap: 8px;
  padding: 0;
  text-align: left;

  span {
    border: 1px solid #b7c1cf;
    border-radius: 50%;
    display: inline-block;
    height: 15px;
    position: relative;
    width: 15px;
  }

  &.active span {
    border-color: #008e75;
  }

  &.active span::after {
    background: #008e75;
    border-radius: 50%;
    content: '';
    height: 7px;
    left: 3px;
    position: absolute;
    top: 3px;
    width: 7px;
  }

  &.muted {
    color: #536074;
  }
}

.recurrence-box {
  background: #ecf8f4;
  border-radius: 5px;
  margin-top: 14px;
  padding: 14px 16px;

  label {
    display: block;
    margin-bottom: 8px;
  }

  p {
    color: #243047;
    margin: 10px 0 0;
  }
}

.repeat-inline {
  align-items: center;
  display: flex;
  gap: 10px;

  .custom-select {
    max-width: 110px;
  }
}

.section-subtitle {
  color: #657085;
  margin: -8px 0 10px;
}

.reminder-options {
  display: flex;
  gap: 28px;
  margin-bottom: 10px;
}

.reminder-row {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: auto minmax(0, 1fr);

  label {
    margin: 0;
  }
}

.upload-drop {
  align-items: center;
  border: 1px dashed #d5dde8;
  border-radius: 7px;
  color: #465267;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  min-height: 72px;
  padding: 14px;
  text-align: center;

  i {
    color: #465267;
    font-size: 24px;
  }

  span {
    font-weight: 500;
  }

  small {
    color: #657085;
  }

  input {
    display: none;
  }
}

.summary-card {
  padding: 0;

  h2 {
    border-bottom: 1px solid #e7edf4;
    margin: 0;
    padding: 18px 20px;
  }
}

.summary-item,
.summary-dates {
  border-bottom: 1px solid #e7edf4;
  padding: 12px 20px;
}

.summary-item {
  display: grid;
  gap: 4px;

  span {
    color: #657085;
    font-size: 13px;
  }

  strong {
    color: #172033;
    font-size: 14px;
    font-weight: 600;
  }

  button {
    background: transparent;
    border: 0;
    color: #008e75;
    font-weight: 600;
    padding: 0;
    text-align: left;
  }

  .summary-value {
    color: #008e75;
    font-size: 22px;
  }
}

.summary-dates {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  span,
  small {
    color: #657085;
    display: block;
    font-size: 13px;
  }

  strong {
    color: #172033;
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-top: 6px;
  }
}

.receivable-tip {
  background: #eefaf5;

  p {
    color: #243047;
    line-height: 1.5;
    margin: 0;
  }
}

.shortcuts-card {
  button {
    background: transparent;
    border: 0;
    color: #008e75;
    display: block;
    font-weight: 600;
    margin-bottom: 10px;
    padding: 0;
    text-align: left;
  }
}

.quick-create-grid {
  display: grid;
  gap: 12px;

  label,
  legend {
    color: #172033;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .form-group {
    margin-bottom: 0;
  }

  .form-control {
    border-color: #d8dee8;
    border-radius: 5px;
    min-height: 40px;
  }
}

.quick-create-actions {
  border-top: 1px solid #e7edf4;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 18px;
  padding-top: 16px;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 700;
    justify-content: center;
    margin: 0;
    min-height: 40px;
    min-width: 132px;
  }
}

.history-screen {
  background: #f5f7fb;
  border-radius: 7px;
  display: grid;
  gap: 14px;
  margin-top: 8px;
  padding: 14px;
}

.history-topbar,
.history-actions,
.history-client-card,
.history-client-main,
.history-client-metrics,
.history-kpis,
.history-filters,
.history-table-head,
.history-footer,
.history-send-actions {
  align-items: center;
  display: flex;
}

.history-topbar {
  justify-content: space-between;
}

.history-breadcrumb {
  color: #647084;
  font-size: 12px;
  margin-bottom: 6px;
}

.history-topbar h2 {
  color: #172033;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.history-actions,
.history-send-actions {
  gap: 10px;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    gap: 7px;
    height: 36px;
    justify-content: center;
    margin: 0;
  }
}

.history-client-card,
.history-kpis article,
.history-filters,
.history-table-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.history-client-card {
  justify-content: space-between;
  padding: 18px 20px;
}

.history-client-main {
  gap: 14px;
}

.history-company-icon {
  align-items: center;
  background: #e7f5ef;
  border-radius: 7px;
  color: #008e75;
  display: inline-flex;
  font-size: 24px;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.history-client-main strong,
.history-client-main span,
.history-client-main small {
  display: block;
}

.history-client-main strong {
  color: #172033;
  font-weight: 700;
}

.history-client-main span,
.history-client-main small {
  color: #647084;
  font-size: 12px;
  margin-top: 3px;
}

.history-client-metrics {
  border-left: 1px solid #dfe6ef;
  gap: 32px;
  padding-left: 28px;
}

.history-client-metrics div {
  display: grid;
  gap: 2px;
}

.history-client-metrics span,
.history-client-metrics small {
  color: #647084;
  font-size: 12px;
}

.history-client-metrics strong {
  color: #172033;
  font-size: 13px;

  &.is-good {
    color: #008e75;
  }
}

.history-kpis {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.history-kpis article {
  display: grid;
  gap: 8px;
  padding: 16px;
}

.history-kpis span {
  color: #008e75;
  font-size: 12px;
  font-weight: 700;

  &.is-positive {
    color: #008e75;
  }

  &.is-negative {
    color: #dc3545;
  }
}

.history-kpis small {
  color: #647084;
}

.history-kpis strong {
  color: #172033;

  &.is-danger {
    color: #dc3545;
  }
}

.history-filters {
  gap: 10px;
  padding: 10px;

  input,
  select {
    border: 1px solid #d8dee8;
    border-radius: 5px;
    color: #172033;
    height: 34px;
    min-width: 130px;
    padding: 0 10px;
  }

  > span {
    color: #647084;
  }

  > button {
    align-items: center;
    background: #e7f1ef;
    border: 0;
    border-radius: 5px;
    color: #172033;
    display: inline-flex;
    height: 34px;
    justify-content: center;
    width: 34px;
  }
}

.history-search {
  align-items: center;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  display: flex;
  flex: 1;
  gap: 8px;
  height: 34px;
  min-width: 240px;
  padding: 0 10px;

  i {
    color: #647084;
  }

  input {
    border: 0;
    flex: 1;
    height: auto;
    min-width: 0;
    padding: 0;
  }
}

.history-table-card {
  overflow: hidden;
}

.history-table-head {
  justify-content: space-between;
  padding: 16px 18px;

  h3 {
    align-items: center;
    color: #172033;
    display: flex;
    font-size: 15px;
    font-weight: 700;
    gap: 8px;
    margin: 0;
  }

  h3 i {
    color: #008e75;
  }

  span {
    color: #647084;
    font-size: 12px;
  }
}

.history-table-wrap {
  overflow-x: auto;
}

.history-table {
  border-collapse: collapse;
  min-width: 760px;
  width: 100%;

  th {
    background: #eef3fb;
    color: #647084;
    font-size: 12px;
    font-weight: 700;
    padding: 14px;
    text-align: left;
    text-transform: uppercase;
  }

  td {
    border-top: 1px solid #e7edf4;
    color: #172033;
    font-size: 13px;
    padding: 13px 14px;
    vertical-align: middle;
  }

  td strong,
  td span {
    display: block;
  }

  td span {
    color: #647084;
    font-size: 12px;
    margin-top: 2px;
  }

  .is-danger {
    color: #dc3545;
  }
}

.history-status {
  border-radius: 999px;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;

  &.is-aberto {
    background: #e8f1ff;
    color: #1f6feb;
  }

  &.is-pago {
    background: #e7f5ef;
    color: #008e75;
  }

  &.is-atrasado {
    background: #ffe9ed;
    color: #dc3545;
  }
}

.history-more {
  background: transparent;
  border: 0;
  color: #172033;
  font-size: 18px;
}

.history-empty {
  color: #647084;
  text-align: center;
}

.history-footer {
  color: #647084;
  font-size: 12px;
  justify-content: space-between;
  padding: 14px 18px;
}

.history-send-actions {
  justify-content: flex-end;
}

@media (max-width: 1199px) {
  .receivable-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .receivable-dashboard-bottom {
    grid-template-columns: 1fr;
  }

  .receivable-grid {
    grid-template-columns: 1fr;
  }

  .receivable-aside {
    position: static;
  }

  .history-client-card,
  .history-client-metrics,
  .history-topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .history-client-metrics {
    border-left: 0;
    border-top: 1px solid #dfe6ef;
    gap: 16px;
    padding-left: 0;
    padding-top: 16px;
    width: 100%;
  }

  .history-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .bloco {
    padding: 18px;
  }

  .receivable-page-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .receivable-page-actions .btn {
    width: 100%;
  }

  .receivable-filter-drawer {
    width: 100vw;
  }

  .receivable-filter-actions {
    grid-template-columns: 1fr;
  }

  .receivable-kpi-grid {
    grid-template-columns: 1fr;
  }

  .receivable-list-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .receivable-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .receivable-actions {
    justify-content: flex-start;
    width: 100%;

    .btn {
      flex: 1 1 auto;
      justify-content: center;
    }
  }

  .receivable-form-grid.two-cols,
  .receivable-form-grid.four-cols,
  .receivable-split,
  .summary-dates {
    grid-template-columns: 1fr;
  }

  .input-with-action,
  .value-row,
  .reminder-row {
    grid-template-columns: 1fr;
  }

  .history-actions,
  .history-filters,
  .history-send-actions {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .history-actions .btn,
  .history-send-actions .btn,
  .history-search,
  .history-filters input,
  .history-filters select {
    width: 100%;
  }

  .history-kpis {
    grid-template-columns: 1fr;
  }
}
</style>
